export interface EventRSVP {
  attending: boolean;
  mealChoice?: string;
  dietaryRestrictions?: string;
}

export interface GuestRSVP {
  welcomeParty: EventRSVP;
  wedding: EventRSVP;
  additionalEvents: {
    needsLodging: boolean;
    needsTransportation: boolean;
  };
  transportation?: {
    option: string;
  };
  email?: string; // Add email field to GuestRSVP
}

export interface GroupRSVP {
  email?: string;
}

export interface Guest {
  groupId: string;
  guestId: string;
  firstName: string;
  lastName: string;
  relationship?: string;
  rsvp?: GuestRSVP;
}

export interface GuestGroup {
  groupId: string;
  guests: Guest[];
}

export interface GuestWithRSVP extends Guest {
  rsvp: GuestRSVP;
  address?: string;
  isOutOfTown?: boolean;
  rsvpStatus: 'responded' | 'pending';
}

export async function lookupGuest(firstName: string, lastName: string): Promise<GuestGroup[]> {
  const params = new URLSearchParams({ 
    firstName, 
    lastName 
  });

  const response = await fetch(`/api/rsvps?${params}`);
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Guest not found');
    }
    throw new Error('Failed to lookup guest');
  }

  return response.json();
}

export async function submitRSVP(groupId: string, guestRSVPs: Record<string, GuestRSVP>): Promise<void> {
  const response = await fetch('/api/rsvps', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      groupId,
      rsvps: guestRSVPs,
    }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Failed to submit RSVP' }));
    throw new Error(error.message || 'Failed to submit RSVP');
  }
}

export async function fetchAllRSVPs(passphrase: string): Promise<GuestWithRSVP[]> {
  const response = await fetch('/api/rsvps/all', {
    headers: {
      'Authorization': passphrase
    }
  });
  
  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Unauthorized: Invalid passphrase');
    }
    throw new Error('Failed to fetch RSVPs');
  }

  return response.json();
}
